<template>
  <v-card>
    <v-card-title color="primary" class="headline lighten-2" primary-title>
      {{ $t('Notification options') }}
    </v-card-title>
    <v-card-text v-html="$t('How do you want to notify compensation?')" />
    <v-divider />
    <v-card-actions style="margin-top: 20px">
      <v-col>
        <div style="margin-bottom: 20px">
          <v-slider
            v-model="tick"
            :tick-labels="ticksLabels"
            :max="2"
            step="1"
            ticks="always"
            tick-size="3"
            color="#44E0B2"
            track-color="#636363"
            @change="prova"
          />
        </div>
        <v-row v-if="showWhatsapp ||showSMS" justify="center" style="text-align: center">
          <v-col cols="12">
            <span v-if="showSMS"> {{ $t('Click on the contact to send the message via SMS and check the box') }} </span>
            <span v-else> {{ $t('Click on the contact to send the message via Whatsapp and check the box') }} </span>
          </v-col>
          <v-col cols="12">
            <v-container style="width: 100%">
              <v-row v-for="(user, index) of notificationData" :key="user.cif" justify="center">
                <v-col cols="7" style="padding: 10px 0 0;">
                  <v-text-field
                    v-model="user.phone"
                    :label="$t('Phone of ') + user.cif"
                    name="phone number"
                    required
                    type="number"
                    color="#FF6961"
                    style="font-size: 12px"
                    prepend-icon="mdi-cellphone-iphone"
                  />
                </v-col>
                <v-col cols="2" style="margin-top: 10px; padding: 10px 0 0;">
                  <v-btn class="mx-2 btn-primary" fab small dark @click="sendMessage(user.phone, user.message)">
                    <v-icon> mdi-send </v-icon>
                  </v-btn>
                </v-col>
                <v-col cols="2" style="padding: 10px 0 0;; margin-left: 5px">
                  <v-checkbox v-model="checkboxes[index]" style="font-size: 12px" label="Sent" />
                </v-col>
              </v-row>
            </v-container>
          </v-col>
          <v-col justify="center">
            <v-btn x-large class="btn-primary" dark :disabled="!checkboxes.every(elem => elem)" @click="finishProcess(true)">
              OK <v-icon style="margin-left: 5px">
                mdi-check
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row v-if="autoMailClicked" justify="center" style="text-align: center">
          <v-col cols="12">
            <v-btn x-large class="btn-primary" :loading="loadingBtn" dark @click="finishProcess(false)">
              OK <v-icon style="margin-left: 5px">
                mdi-check
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row justify="center" style="text-align: center">
          <v-col cols="12">
            <v-btn x-large color="secondary" :loading="loadingBtn" style="color: black" @click="back()">
              {{ $t('NotificationTypesForCompensate.DON\'T NOTIFICATE') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-card-actions>
  </v-card>
</template>

<script>
import ApiRepository from "../repositories/ApiRepository";
export default {
    name: "NotificationTypesForCompensate",
    props: {
        notificationData: {
            type: Array,
            default: new Array()
        },
        resultFactoring: {
            type: String,
            default: ""
        }
    },
    data: () => ({
        tick: 0,
        ticksLabels: ['EMAIL', 'SMS', 'WHATSAPP'],
        loadingBtn: false,
        visible: false,
        title: "Title",
        checkbox1: false,
        message: "Message",
        onYes: null,
        onNo: null,
        invoiceAB: null,
        invoiceBC: null,
        showEmails: false,
        showWhatsapp: false,
        checkboxes: [],
        showSMS: false,
        factoring: null,
        whatsappChose: false,
        firstClick: false,
        data: [],
        autoButton: "primary",
        whatsButton: "primary",
        smsButton: "primary",
        manualButton: "primary",
        autoMailClicked: false,
        notificationType: ''
    }),
    created () {
        this.initialiize('A');
    },
    methods: {
        prova () {
            if (this.tick === 0) {
                this.initialiize('A');
            } else  if (this.tick === 1) {
                this.initialiize('S');
            } else  if (this.tick === 2) {
                this.initialiize('W');
            }
        },
        accept () {
            if (this.$data.onYes) {
                this.$data.onYes();
            }
            this.back();
        },
        reject () {
            if (this.$data.onNo) {
                this.$data.onNo();
            }
            this.back();
        },
        setInformation (jInfo) {
            this.title = jInfo.title;
            this.message = jInfo.message;
            this.factoring = jInfo.factoring;
            this.data = jInfo.data;
        },
        handleCallbacks (event) {
            if (typeof event.yes === 'function') {
                this.$data.onYes = event.yes;
            }
            if (typeof event.no === 'function') {
                this.$data.onNo = event.no;
            }
        },
        initialiize ( typeNotification ) {
            if ( !this.firstClick ) {
                for (const user of this.data) {
                    this.checkboxes.push(false);
                }
                this.firstClick = true;
            }

            this.notificationsWays(typeNotification);
        },
        notificationsWays ( notify ) {
            this.notificationType = notify;
            if ( notify === "A" ) { // automatic notification
                this.autoButton = "primary"; this.whatsButton = this.smsButton = this.manualButton = "#909593";
                this.whatsappChose = false; this.showSMS = false; this.showWhatsapp = false;
                this.autoMailClicked = !this.autoMailClicked;
            } else if ( notify === "M" ) { // Enviament de correus manual
                /*
                this.autoMailClicked = false;
                this.manualButton = false; this.smsButton = this.whatsButton = true;
                for (const user of res.data.result) {
                    const email = user.email;
                    const subject = "Bypay";
                    const content = user.message;
                    this.mailTo = "mailto:" + email + "?subject=" + subject + "&body=" + content;
                    window.location.replace(this.mailTo);
                }
              */
            } else if ( notify === "S") { // Enviament via SMS
                this.whatsappChose = false; this.autoMailClicked = false;
                this.smsButton = "primary"; this.whatsButton = this.autoButton = this.manualButton = "#909593";
                this.showSMS = !this.showSMS; this.showWhatsapp = false;
            } else if ( notify === "W") { // Enviament via Whatsapp
                this.whatsButton = "primary"; this.smsButton = this.autoButton = this.manualButton = "#909593";
                this.showSMS = false; this.autoMailClicked = false;
                this.sendWhatsapp();
            }
        },
        isWin () {
            return (!this.isAndroid() && !this.isIOS());
        },
        sendWhatsapp () {
            this.whatsappChose = true;
            this.showWhatsapp = !this.showWhatsapp;
        },
        getHrefAndroid (phone, message) {
            let messageToSend = message;
            const matches = message.match(/\bhttps?:\/\/\S+/);
            if (matches && matches[0]) {
                messageToSend = messageToSend.replace(matches[0].toString(), '');
                messageToSend = [messageToSend.slice(0, matches.index), encodeURIComponent(matches[0]), messageToSend.slice(matches.index)].join('');
            }
            return "sms:" + phone + "?body=" + encodeURIComponent(messageToSend);
        },
        getHrefiOS (phones, message) {
            let messageToSend = message;
            const matches = message.match(/\bhttps?:\/\/\S+/);
            if (matches && matches[0]) {
                messageToSend = messageToSend.replace(matches[0].toString(), '');
                messageToSend = [messageToSend.slice(0, matches.index), matches[0], messageToSend.slice(matches.index)].join('');
            }
            return "sms://open?addresses=" + phones + "/&body=" + encodeURIComponent(messageToSend);
        },
        isAndroid () {
            const userAgent = navigator.userAgent || navigator.vendor || window.opera;
            return /android/i.test(userAgent);
        },
        isIOS () {
            return  !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
        },
        sendSMS (phone, message) {
            if (this.isAndroid())
                window.location.replace(this.getHrefAndroid(phone, message));
            else if (this.isIOS())
                window.location.replace(this.getHrefiOS(phone, message));
        },
        sendWhatsAppMessage (phone, mess) {
            window.open("https://api.whatsapp.com/send?phone=+34" + phone + "&abid=+34677882757&text=" + mess, '_blank');
        },
        sendMessage (phone, message) {
            if (this.whatsappChose) {
                this.sendWhatsAppMessage(phone, encodeURIComponent(message));
            } else {
                this.sendSMS(phone, message);
            }
        },
        finishProcess (onlyMe) {
            this.loadingBtn = true;
            ApiRepository.notify(this.resultFactoring, onlyMe)
                .then(() => {
                    this.back();
                })
                .catch(() => {})
                .finally(() => {
                    this.loadingBtn = false;
                });
        },
        back () {
            this.$emit("back", {});
        }
    },
};
</script>

<style scoped>

</style>
